import { CurrentBodyMapEntriesScreen } from "app/screens/residents/show/CurrentBodyMapEntriesScreen";

export default function CurrentBodyMapEntriesPage() {
  return <CurrentBodyMapEntriesScreen />;
}
